var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        {
          staticClass: "card ma-2 pl-3",
          attrs: {
            color: _vm.displayedTechId === 0 ? "lightgrey" : "opposite",
            id: "techCard-0",
            outlined: ""
          },
          on: {
            click: function($event) {
              return _vm.$emit("display", { id: 0 })
            }
          }
        },
        [
          _c("custom-light-card", {
            attrs: {
              icon: "mdi-map-marker",
              specificTitleClasses: _vm.isPropertyOrdo ? "success--text" : "",
              subtitle: _vm.request.propertyAdress,
              title: _vm.request.property_shortname
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.orderedTechnicians, function(item) {
        return _c(
          "v-card",
          {
            key: item.num,
            staticClass: "card ma-2 pl-3 pb-3",
            attrs: {
              color: _vm.displayedTechId === item.id ? "lightgrey" : "opposite",
              id: `techCard-${item.id}`,
              outlined: ""
            },
            on: {
              click: function($event) {
                return _vm.$emit("display", item)
              }
            }
          },
          [
            _c("custom-light-card", {
              attrs: {
                alert: _vm.getAlertMessage(item),
                icon: item.specific_position.icon,
                specificAlertClasses: "font-weight-light font-italic",
                specificTitleClasses: item.absence_today
                  ? "warning--text"
                  : item.scheduled
                  ? "success--text"
                  : "",
                specificSubtitleClasses: _vm.getSpecificSubtitleClasses(item),
                status: item.specific_status,
                subtitle:
                  item.roles.length > 1
                    ? item.roles
                    : item.specific_position.position,
                title: item.full_name,
                chip: {
                  title: item.absence_today,
                  subtitle: item.hours_of_absence
                }
              }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }